import hubLayout from 'styles/css/hubLayout.module.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { logout } from 'api/bridge';
import { isMobile, removeLocalStorage } from 'api/api';

const BtnComponent = ({ name, url }: { name: string, url: string }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className={`${hubLayout.btn_group}`} style={{ margin: '10px 0' }}>
        <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={() => navigate(url)}>{name}</button>
      </div>
    </>
  );
}

function Menu() {
  const containerRef = useRef<HTMLDivElement>(null);

  const goLogout = (): void => {
    const isApp = isMobile();
    removeLocalStorage();
    if (isApp) {
      logout();
    } else {
      window.location.href = "/admin/login";
    }
  };

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current) {
        const viewportHeight = window.innerHeight;
        containerRef.current.style.height = `${viewportHeight - 57}px`;
      }
    };

    // 초기 설정
    updateHeight();

    // 리사이즈 이벤트에 대응
    window.addEventListener('resize', updateHeight);

    // 클린업 함수로 이벤트 제거
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);
  return (
    <>
      <div ref={containerRef} className={`${hubLayout.cnt_box}`}>
        <div className={`${hubLayout.acc__cnt}`} style={{
            height: 'calc(100% + 57px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          {/* 로고 */}
          <div>
            <img src="/image/FOCUSAI_Red_Black_vertical.png" alt="logo" style={{ width: '60%' }}/>
          </div>
          <h2 style={{ margin: '5rem 0 2rem 0' }}>원하시는 업무를 선택하세요.</h2>
          <BtnComponent name="매니저 OTP 생성" url="/agent/manager-otp/register" />
          <BtnComponent name="계약 관리" url="/agent/contract/management" />
          {/* <BtnComponent name="계정 등록" url="/agent/user/register" /> */}
          <BtnComponent name="장비 관리" url="/agent/search/user" />
          <div className={`${hubLayout.btn_group}`}>
            <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={goLogout}>로그아웃</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Menu;